import * as React from 'react';
import {  IconButton, CardActions, Box } from '@mui/material';
import { useStyles } from './style';

const CardActionComponent = ({
  actionsIcons,
  handleActionClick,
  row,
}) => {
  const classes = useStyles()
  return (
      <CardActions>
        <Box className={classes.actionBox} component='div'>
        {actionsIcons.map((item, index) =>
          item.allowedWhen &&
          row[item.allowedWhen] &&
          Object.keys(row[item.allowedWhen]).length > 0 ? (
            <IconButton
              onClick={() => handleActionClick(index, row)}
              className={classes.iconBox}
              key={index + 'icons'}
            >
              {item.icon}
            </IconButton>
          ) : (
            !item.allowedWhen && (
              <IconButton
                onClick={() => handleActionClick(index, row)}
                className={classes.iconBox}
                key={index + 'icons'}
              >
                {item.icon}
              </IconButton>
            )
          )
        )}
        </Box>
      </CardActions>

  );
};

export default CardActionComponent;
